import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../lib/motion";

/** Wraps a routed page so it fades/rises in on mount and fades out on unmount (see AnimatePresence in routes). */
const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div variants={pageVariants} initial="initial" animate="enter" exit="exit">
    {children}
  </motion.div>
);

export default PageTransition;
